// SAJAFO — voegt een aparte "Personalisatie toeslag" toe aan het winkelmandje
// zodra iemand een product personaliseert:
// - kapjes: optionele personalisatie (checkbox, één kant) -> €1,00-toeslagproduct
// - twee-kanten-producten (pop-up portemonnees, houten sleutelhangers): twee
//   onafhankelijke optionele kanten (voorkant/achterkant, elk een checkbox) ->
//   precies één kant gepersonaliseerd = het €1,00-toeslagproduct, allebei de
//   kanten gepersonaliseerd = het aparte €2,00-toeslagproduct (niet 2x het €1-product).
// Houdt beide toeslagregels daarna altijd gelijk aan het aantal winkelwagen-items
// dat ze nodig heeft (ook als de klant de hoeveelheid later aanpast of verwijdert).
(function () {
  var SINGLE_VARIANT_ID = 54873448939863; // Personalisatie toeslag, € 1,00
  var DOUBLE_VARIANT_ID = 54893040238935; // Personalisatie toeslag, € 2,00 (voor- én achterkant)

  var SURCHARGE_HANDLES = [
    'beschermkapje-voor-tomtom-rider-navigatie',
    'beschermkapje-voor-garmin-zumo-navigatie',
  ];
  var TWO_SIDED_HANDLES = [
    'rfid-portemonnee-zwart-pop-up',
    'rfid-portemonnee-rood-pop-up',
    'rfid-portemonnee-blauw-pop-up',
    'rfid-portemonnee-geel-pop-up',
    'rfid-portemonnee-groen-pop-up',
    'rfid-portemonnee-oranje-pop-up',
    'sleutelhanger-hout-rechthoek',
    'sleutelhanger-hout-rechthoek-luxe',
    'sleutelhanger-hout-rond',
    'sleutelhanger-hout-rechthoek-luxe-kopie',
  ];
  var syncing = false;

  function getQuantity() {
    var productInfo = document.querySelector('product-info');
    var qtyInput = productInfo && productInfo.quantityInput;
    var value = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return value > 0 ? value : 1;
  }

  function renderCartSections(response) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;
    cartDrawer.renderContents(response);
    // Dawn's eigen product-form.js ruimt deze klasse op na een add-to-cart
    // (product-form.js regel ~115); omdat de toeslag hier via een eigen
    // /cart/add.js-aanroep loopt (buiten product-form.js om), moeten we dat zelf
    // doen — anders blijft cart-drawer.js denken dat het mandje nog leeg is en
    // crasht de focus-val zodra de openings-animatie eindigt (alleen zichtbaar
    // als het mandje leeg was vóór deze toevoeging).
    if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
  }

  function getSections() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return null;
    return cartDrawer.getSectionsToRender().map(function (section) { return section.id; });
  }

  function addSurcharge(variantId, qty) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', qty);
    var sections = getSections();
    if (sections) {
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) return;
        renderCartSections(response);
      })
      .catch(function () {});
  }

  function hasPersonalization(item) {
    var props = item.properties || {};
    return !!(props['Personalisatie tekst'] || props['Personalisatie afbeelding']);
  }

  function hasFrontPersonalization(item) {
    var props = item.properties || {};
    return !!(props['Personalisatie voorkant tekst'] || props['Personalisatie voorkant afbeelding']);
  }

  function hasBackPersonalization(item) {
    var props = item.properties || {};
    return !!(props['Personalisatie achterkant tekst'] || props['Personalisatie achterkant afbeelding']);
  }

  function desiredQuantities(items) {
    var single = 0;
    var double = 0;
    items.forEach(function (item) {
      if (SURCHARGE_HANDLES.indexOf(item.handle) !== -1 && hasPersonalization(item)) {
        single += item.quantity;
      }
      if (TWO_SIDED_HANDLES.indexOf(item.handle) !== -1) {
        var sides = (hasFrontPersonalization(item) ? 1 : 0) + (hasBackPersonalization(item) ? 1 : 0);
        if (sides === 1) single += item.quantity;
        else if (sides === 2) double += item.quantity;
      }
    });
    return { single: single, double: double };
  }

  function changeLineQuantity(variantId, quantity, sections) {
    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: String(variantId),
        quantity: quantity,
        sections: sections,
        sections_url: window.location.pathname,
      }),
    }).then(function (res) { return res.json(); });
  }

  // Houdt beide toeslagregels gelijk aan het aantal gepersonaliseerde kanten in de
  // winkelwagen, telkens wanneer de winkelwagen wijzigt via de +/- knoppen of het
  // verwijderen van een regel (niet via het toevoegen vanaf de productpagina, dat
  // loopt via de submit-handler hieronder en telt in één request meteen goed op).
  function syncSurchargeLine(cart) {
    if (syncing) return;

    var items = cart.items || [];
    var singleLine = items.filter(function (item) { return item.variant_id === SINGLE_VARIANT_ID; })[0];
    var doubleLine = items.filter(function (item) { return item.variant_id === DOUBLE_VARIANT_ID; })[0];
    var desired = desiredQuantities(items);
    var currentSingle = singleLine ? singleLine.quantity : 0;
    var currentDouble = doubleLine ? doubleLine.quantity : 0;

    if (desired.single === currentSingle && desired.double === currentDouble) return;

    syncing = true;
    var sections = getSections() || [];
    var chain = Promise.resolve();
    var lastResponse = null;

    if (desired.single !== currentSingle) {
      chain = chain.then(function () {
        return changeLineQuantity(SINGLE_VARIANT_ID, desired.single, sections).then(function (response) {
          lastResponse = response;
        });
      });
    }
    if (desired.double !== currentDouble) {
      chain = chain.then(function () {
        return changeLineQuantity(DOUBLE_VARIANT_ID, desired.double, sections).then(function (response) {
          lastResponse = response;
        });
      });
    }

    chain
      .then(function () {
        if (lastResponse && !lastResponse.status) renderCartSections(lastResponse);
      })
      .catch(function () {})
      .finally(function () {
        syncing = false;
      });
  }

  function hasContent(block) {
    var toggle = block.querySelector('[data-se-personalize-toggle]');
    if (toggle && !toggle.checked) return false;
    var tabText = block.querySelector('[data-se-tab="text"]');
    var textInput = block.querySelector('[data-se-engrave-text]');
    var fileInput = block.querySelector('[data-se-engrave-file]');
    var isTextActive = tabText && tabText.classList.contains('active');
    if (isTextActive) return !!(textInput && textInput.value.trim() !== '');
    return !!(fileInput && fileInput.files && fileInput.files.length > 0);
  }

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.source === 'cart-items' && event.cartData && event.cartData.items) {
          syncSurchargeLine(event.cartData);
        }
      });
    }

    // Eén optioneel blok (kapjes) of twee onafhankelijke optionele blokken
    // (voorkant + achterkant van een twee-kanten-product) kunnen op deze pagina
    // voorkomen — beide gebruiken hetzelfde data-attribuut.
    var surchargeBlocks = Array.prototype.slice.call(document.querySelectorAll('[data-se-surcharge-variant-id]'));
    if (surchargeBlocks.length === 0) return;

    var form = document.querySelector('product-form form');
    if (!form) return;

    function activeBlocks() {
      return surchargeBlocks.filter(hasContent);
    }

    function chosenVariantId(units) {
      return units === 2 ? DOUBLE_VARIANT_ID : SINGLE_VARIANT_ID;
    }

    // Tekst-personalisatie (één of beide kanten): het hoofdproduct en de juiste
    // toeslag (€1 of €2) worden in ÉÉN /cart/add.js-aanroep tegelijk toegevoegd
    // (Shopify's "items"-array), zodat het winkelmandje in één keer het juiste
    // totaal toont in plaats van eerst het productbedrag en een fractie later het
    // bedrag inclusief toeslag. Bij een afbeelding-upload (multipart bestand) kan
    // dat niet in dezelfde JSON-aanroep, dus die volgt de oude twee-staps-aanpak
    // hieronder.
    document.addEventListener(
      'submit',
      function (event) {
        if (event.target !== form) return;
        // Een verplicht of groeps-gevalideerd personalisatieblok kan deze submit
        // al hebben afgekeurd en preventDefault() hebben aangeroepen — in dat
        // geval mag deze losse toeslag-aanvraag niet alsnog doorgaan.
        if (event.defaultPrevented) return;

        var active = activeBlocks();
        if (active.length === 0) return;
        if (active.some(function (b) { return b.querySelector('[data-se-engrave-file]') && b.querySelector('[data-se-engrave-file]').files.length > 0; })) return;

        event.preventDefault();
        event.stopPropagation();

        var productFormEl = form.closest('product-form');
        var submitButton = productFormEl && productFormEl.querySelector('[type="submit"]');
        var qty = getQuantity();
        var formData = new FormData(form);
        var mainVariantId = formData.get('id');
        var properties = {};
        formData.forEach(function (value, key) {
          var match = key.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        });

        var payload = {
          items: [
            { id: mainVariantId, quantity: qty, properties: properties },
            { id: chosenVariantId(active.length), quantity: qty },
          ],
        };
        var sections = getSections();
        if (sections) {
          payload.sections = sections;
          payload.sections_url = window.location.pathname;
        }

        if (submitButton) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        }

        fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })
          .then(function (res) { return res.json(); })
          .then(function (response) {
            if (response.status) return;
            renderCartSections(response);
          })
          .catch(function () {})
          .finally(function () {
            if (submitButton) {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            }
          });
      },
      true
    );

    // Afbeelding-upload op minstens één kant: originele twee-staps-aanpak (het
    // hoofdproduct gaat via Dawn's eigen submit — zodat het bestand native als
    // multipart meegaat — de juiste toeslag (€1 of €2) volgt hierna apart).
    var pendingQty = null;
    var pendingVariantId = null;

    form.addEventListener('submit', function () {
      var active = activeBlocks();
      var hasFile = active.some(function (b) {
        var f = b.querySelector('[data-se-engrave-file]');
        return f && f.files && f.files.length > 0;
      });
      if (active.length > 0 && hasFile) {
        pendingQty = getQuantity();
        pendingVariantId = chosenVariantId(active.length);
      } else {
        pendingQty = null;
        pendingVariantId = null;
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.source !== 'product-form' || pendingQty === null) return;
        var qty = pendingQty;
        var variantId = pendingVariantId;
        pendingQty = null;
        pendingVariantId = null;
        addSurcharge(variantId, qty);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
